import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useCreateVendorDataMutation } from "store/services/CanUsers/vendorApi";
import VendorForm from "./vendorComponents/VendorForm";

const VendorCreateScreen = () => {
  const [createVendor, { isLoading: creatingVendor }] =
    useCreateVendorDataMutation();
  const navigate = useNavigate();

  const breadcrumbs = [
    {
      title: "Vendors",
      path: "/app/crm/vendor/list",
    },

    { title: "New Vendor " },
  ];

  // create Vendor
  const handleCreateVendor = async (data) => {
    createVendor(data)
      .unwrap()
      .then(() => {
        navigate(breadcrumbs[0].path);
        toast.success("Vendor created successfully");
      })
      .catch((error) => {
        const errorMessage = error?.data?.message || "Something went wrong!";
        toast.error(errorMessage);
      });
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingVendor}>
      <BreadcrumbLayout.Paper>
        <VendorForm isBusy={creatingVendor} onSubmit={handleCreateVendor} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default VendorCreateScreen;
